"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GRAPHQL_QUERY = exports.URL = void 0;
exports.URL = {
    dev: {
        graphql: `https://insight-api.eccr-stg.autodesk.com/graphql`,
        rest: "https://reporting-api.eccr-stg.autodesk.com/insights/v1/insights?details=true",
    },
    stg: {
        graphql: `https://insight-api.eccr-stg.autodesk.com/graphql`,
        rest: "https://reporting-api.eccr-stg.autodesk.com/insights/v1/insights?details=true",
    },
    prd: {
        graphql: `https://insight-api.eccr.autodesk.com/graphql`,
        rest: "https://reporting-api.eccr.autodesk.com/insights/v1/insights?details=true",
    },
};
exports.GRAPHQL_QUERY = {
    insight: `query Insight(
  $insightId: String!
  $documentId: String
  $contextId: String
  $showInternal: Boolean
  $language: String
  $detailed: Boolean
  $clientVersion: String
) {
  insight(
    insightId: $insightId
    documentId: $documentId
    contextId: $contextId
    showInternal: $showInternal
    language: $language
    detailed: $detailed
    clientVersion: $clientVersion
  ) {
    id
    name
    contextId
    userId
    documentId
    content {
      ... on ChartContent {
        type
        name
        options
        columns {
          id
          label
          type
          visualization {
            type
            options
            colors
            legends
            __typename
          }
          __typename
        }
        previewImageFallbackIcon
        previewImageUrl
        fragments
      }
      ... on MediaContent {
        videoUrl
        thumbnailUrl
        previewImageFallbackIcon
        previewImageUrl
        fragments
      }
      ... on WebContent {
        url
        embed
        dialogConfig {
          title
          timeout
          width
          height
          horizontalAlign
          verticalAlign
          triggerEvent
          initScript
          __typename
        }
        previewImageFallbackIcon
        previewImageUrl
        fragments
      }
    }
    scope
    createdTs
    lastUpdatedTs
    expirationTs
    title
    description
    productName
    productLineCode
    actions {
      title
      name
      parameters
      contentUrl
      __typename
    }
    summaryActions {
      title
      name
      parameters
      __typename
    }
    fragments
    userList
    visualization
    visualizationOptions {
      options
      colors
      __typename
    }
    visualizationData
    feedback {
      useful
      accurate
      showMore
      comment
      __typename
    }
    feedbackEnabled
    snoozeEnabled
    source
    sourceUuid
    payloadUrl
    categories
    chartData {
      data
      columns {
        id
        label
        type
        visualization {
          type
          options
          colors
          legends
          __typename
        }
        __typename
      }
      series
      donut_chart_data
      __typename
    }
    tealiumTag
    thumbnailUrl
    sample
    stringValues {
      name
      value
      value_type
      __typename
    }
    numericValues {
      name
      value
      value_type
      __typename
    }
    timeSeriesValues {
      name
      value
      __typename
    }
    jsonValues {
      name
      value
      value_type
      __typename
    }
    documentType
    documentSource
    contentName
    additionalPlcs
    additionalUsers {
      userId
      imageUrl
      __typename
    }
    __typename
  }
}
`,
    insights: `query Insights(
  $documentId: String
  $contextId: String
  $productLineCode: String
  $categories: [String]
  $insightName: String
  $contentName: String
  $language: String
  $detailed: Boolean
  $clientType: String
  $clientVersion: String
  $markRead: Boolean
  $scope: String
  $showSamples: Boolean
  $showSnoozed: Boolean
  $showInternal: Boolean
  $pagination: PaginationInput
) {
  insights(
    documentId: $documentId
    contextId: $contextId
    productLineCode: $productLineCode
    categories: $categories
    insightName: $insightName
    contentName: $contentName
    language: $language
    detailed: $detailed
    clientType: $clientType
    clientVersion: $clientVersion
    markRead: $markRead
    scope: $scope
    showSamples: $showSamples
    showSnoozed: $showSnoozed
    showInternal: $showInternal
    pagination: $pagination
  ) {
    pagination {
      limit
      cursor
      __typename
    }
    insights {
      id
      name
      contextId
      userId
      documentId
      content {
        ... on ChartContent {
          type
          name
          options
          columns {
            id
            label
            type
            visualization {
              type
              options
              colors
              legends
              __typename
            }
            __typename
          }
          previewImageFallbackIcon
          previewImageUrl
          fragments
        }
        ... on MediaContent {
          videoUrl
          thumbnailUrl
          previewImageFallbackIcon
          previewImageUrl
          fragments
        }
        ... on WebContent {
          url
          embed
          dialogConfig {
            title
            timeout
            width
            height
            horizontalAlign
            verticalAlign
            triggerEvent
            initScript
            __typename
          }
          previewImageFallbackIcon
          previewImageUrl
          fragments
        }
      }
      scope
      createdTs
      lastUpdatedTs
      expirationTs
      title
      description
      productName
      productLineCode
      actions {
        title
        name
        parameters
        contentUrl
        __typename
      }
      summaryActions {
        title
        name
        parameters
        __typename
      }
      fragments
      userList
      visualization
      visualizationOptions {
        options
        colors
        __typename
      }
      visualizationData
      feedback {
        useful
        accurate
        showMore
        comment
        __typename
      }
      feedbackEnabled
      snoozeEnabled
      source
      sourceUuid
      payloadUrl
      categories
      chartData {
        data
        columns {
          id
          label
          type
          visualization {
            type
            options
            colors
            legends
            __typename
          }
          __typename
        }
        series
        donut_chart_data
        __typename
      }
      tealiumTag
      thumbnailUrl
      sample
      stringValues {
        name
        value
        value_type
        __typename
      }
      numericValues {
        name
        value
        value_type
        __typename
      }
      timeSeriesValues {
        name
        value
        __typename
      }
      jsonValues {
        name
        value
        value_type
        __typename
      }
      documentType
      documentSource
      contentName
      additionalPlcs
      additionalUsers {
        userId
        imageUrl
        __typename
      }
      __typename
    }
    __typename
  }
}
`,
    getInsightRules: `query GetInsightRules($product: String!, $version: String) {
  getInsightRules(product: $product, version: $version) {
    productLineCode
    versionConstraint
    url
    checksum
    lastUpdatedTs
    rulesEngine
    __typename
  }
}
`,
    getInsightRulesEngines: `query GetInsightRulesEngines(
  $engine: String!
  $latest: Boolean!
  $version: String
) {
  getInsightRulesEngines(engine: $engine, latest: $latest, version: $version) {
    engine
    version
    url
    checksum
    lastUpdatedTs
    __typename
  }
}
`,
};
